import { Component } from '@angular/core';
import { NgControl, FormBuilder, Validators } from '@angular/forms';
import {
	FormConfig,
	CustomFormAccessor,
} from 'src/shared/form-models/form-cva.component';
import { RailroadLink } from 'src/shared/api';
import { FieldTeamDetailGeneralInformation } from '../field-team-detail.models';
import { Store } from '@ngrx/store';
import { RailroadDetailsState } from 'src/admin-app/railroads/railroad-detail/+state/railroad-detail.reducer';
import * as FieldTeamDetailActions from '../+state/field-team-detail.actions';

const teamGeneralInfoFormConfig: FormConfig<FieldTeamDetailGeneralInformation> =
	{
		id: [''],
		fieldManager: ['', [Validators.required]],
		emailAddress: ['', [Validators.required, Validators.email]],
		name: ['', [Validators.required]],
	};

@Component({
	selector: 'rpfsa-team-general-info',
	templateUrl: './general-info.component.html',
})
export class GeneralInfoComponent extends CustomFormAccessor<FieldTeamDetailGeneralInformation> {
	constructor(
		public ngControl: NgControl,
		public fb: FormBuilder,
		private readonly store: Store<{
			railroads: RailroadDetailsState;
		}>
	) {
		super(ngControl, fb, teamGeneralInfoFormConfig);
	}

	railroadSelected(railroad: RailroadLink): void {
		this.store.dispatch(
			FieldTeamDetailActions.railroadSelected({ railroad })
		);
	}
}
